import { ApiResponse, getRequest } from "@/data/apiClient";
import { Role } from "@/data/repos/rolesList";

export interface CheckSavedSessionResponse {
  clientKey: string;
  userId: string;
  userName: string;
  sessionId: string;
  expirationTimestamp: string;
  firstName: string;
  lastName: string;
  micadUser: boolean;
  roles: Role[];
  errorMessage?: string;
}

export async function checkSavedSession(): Promise<
  ApiResponse<CheckSavedSessionResponse>
> {
  return getRequest("user/savedSession", {});
}
